// import React, { useState, useEffect } from 'react'
import React from 'react'
import PropTypes from 'prop-types'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
// import { LoaderDots } from '../../../../../components'
import { GridWrapper, TableWrapper } from './style'
// import { consoleLog } from '../../../../../util'

const Grid = ({ gridData }) => {
  // const [gridData, setGridData] = useState([])
  // const [loader, setLoader] = useState(true)
  // const [deleteObject, setDeleteObject] = useState(null)
  // const { company } = useGlobalStore()

  // const onload = async () => {
  //   setLoader(true)
  //   const payload = { organizationId: company?.OrganizationId }
  //   const response = await keywordManagement.getOrganizationAggregationKeywordDetailsApi(payload)
  //   setGridData(response)
  //   setTimeout(() => {
  //     setLoader(false)
  //   }, 500)
  // }

  // useEffect(() => {
  //   onload()
  // }, [refreshData])

  // useEffect(() => {
  //   onload()
  // }, [company?.OrganizationId])

  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          {gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                {/* <TableCell>Sr.</TableCell> */}
                <TableCell>Keyword</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Sub Type</TableCell>
                <TableCell>Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    {/* <TableCell>{index + 1}</TableCell> */}
                    <TableCell>{row.KeywordValue}</TableCell>
                    <TableCell>{row.KeywordNotesValue}</TableCell>
                    <TableCell>{row.KeywordTypeValue}</TableCell>
                    <TableCell>{row.KeywordSubTypeValue}</TableCell>
                    <TableCell>{row?.KeywordTypeCount || row?.KeywordSubTypeCount || row?.KeywordNotesCount || row?.KeywordCount}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}

          {/* {deleteObject && <Confirmation
            open={true}
            title='Are you sure you want to delete this row?'
            onClose={() => setDeleteObject(null)}
            onCancel={() => setDeleteObject(null)}
            onSubmit={() => deleteFunc(deleteObject)}
          />} */}

          {/* {loader && <LoaderDots /> } */}
          {gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

Grid.propTypes = {
  gridData: PropTypes.array
}

export default Grid
